export default __webpack_public_path__ + "static/media/smetana.5fc9fb24.png";